export default __webpack_public_path__ + "static/media/icon-avatar.bff0fc9d.svg";